import React from "react";
const Pegawai = React.lazy(() => import('./Pegawai'));
const DetailPegawai = React.lazy(() => import('./Pegawai/Detail'));
const PrintPegawai = React.lazy(() => import('./Pegawai/Print'));
const IPASN = React.lazy(() => import('./IPASN'));
const NominatifPegawai = React.lazy(() => import('./NominatifPegawai'))

export const kepegawaianConfig = [
    {
        path: '/apps/kepegawaian/ipasn',
        element: <IPASN />
    },
    {
        path: '/apps/kepegawaian/karyawan',
        element: <Pegawai />
    },
    {
        path: '/apps/kepegawaian/karyawan/detail/:id',
        element: <DetailPegawai />
    },
    {
        path: '/apps/kepegawaian/karyawan/detail/:id/print',
        element: <PrintPegawai />
    },
    {
        path: '/apps/kepegawaian/nominatif-pegawai',
        element: <NominatifPegawai />
    },
];

